import { DeliveryType } from '@/resources/enums'
import { TURBO_COLORS, TurboColor } from '@/resources/enums/orders'
import emotionTheme from '@/styles/theme.ts'
import {
  IN_SEPARATION_SLA_MINUTES,
  IN_SEPARATION_SLA_MINUTES_TURBO,
  ON_GOING_SLA_MINUTES,
  ON_GOING_SLA_MINUTES_TURBO,
} from '@/resources/constants/orders'

export const getCardColorByType = (
  type: DeliveryType,
  turboColor?: TurboColor
) => {
  switch (type) {
    case DeliveryType.TURBO:
      return turboColor
        ? TURBO_COLORS[turboColor]
        : TURBO_COLORS[TurboColor.YELLOW]
    case DeliveryType.SCHEDULED:
      return '#6A21B4'
    case DeliveryType.PICKUP:
      return emotionTheme.ds.ColorBaseBlueLevel6
    case DeliveryType.RECEIVE:
    default:
      return emotionTheme.ds.ColorBaseGreyLevel3
  }
}

export const getProgressCircleCircumference = (radius?: string | number) => {
  const numRadius = Number(radius)
  return isNaN(numRadius) ? 0 : Math.round(2 * Math.PI * numRadius)
}

export const getInSeparationSlaMinutes = (deliveryType: DeliveryType) =>
  deliveryType === DeliveryType.TURBO
    ? IN_SEPARATION_SLA_MINUTES_TURBO
    : IN_SEPARATION_SLA_MINUTES

export const getOnGoingSlaMinutes = (deliveryType: DeliveryType) =>
  deliveryType === DeliveryType.TURBO
    ? ON_GOING_SLA_MINUTES_TURBO
    : ON_GOING_SLA_MINUTES
